import POIStep from "@/components/POI/POIStep/POIStep.vue";
import POITrackStateFields from "@/components/POI/POIStateFields/POITrackStateFields/POITrackStateFields.vue";

export default {
  components: { POIStep, POITrackStateFields },
  props: ["step", "position", "editedItem", "isOwnedBySubPrincipal"],
  methods: {
    changeStep(position) {
      this.$emit("changeStep", position);
    }
  }
};
